const Index = () => import(/* webpackChunkName: "Delivery" */ './index.vue');
const List = () => import(/* webpackChunkName: "Delivery" */ './components/List.vue');
const Create = () => import(/* webpackChunkName: "Delivery" */ './components/Create.vue');
const Edit = () => import(/* webpackChunkName: "Delivery" */ './components/Edit.vue');

export default [
  {
    path: 'Delivery',
    name: 'Delivery',
    component: Index,
    title: 'Delivery',
    redirect: { name: 'delivery-list' },
    children: [
      {
        path: 'list',
        name: 'delivery-list',
        component: List,
      },
      {
        path: 'create',
        name: 'delivery-create',
        component: Create,
      },
      {
        path: 'edit/:id',
        name: 'delivery-edit',
        component: Edit,
      },
      // {
      //   path: 'profile/:id',
      //   name: "Delivery-profile",
      //   component: Profile
      // }
    ],
    
  },
]
